<form class="space-y-8">
  <!-- Identifiant Principal (MIS EN VALEUR) -->
  <div class="p-6 bg-primary-1 border border-primary-3 rounded-2xl space-y-4">
    <div class="flex items-center gap-2 text-primary-11">
      <mat-icon>verified_user</mat-icon>
      <h3 class="text-lg font-bold text-neutral-12">Identifiant professionnel</h3>
    </div>
    <p class="text-sm text-neutral-11">
      Saisissez votre numéro officiel CCI pour récupérer automatiquement vos informations enregistrées.
    </p>

    <mat-form-field class="w-full" appearance="fill">
      <mat-label>{{ cardLabel() }}</mat-label>
      <input
        matInput
        id="agent-card-number"
        name="agent-card-number"
        autocomplete="off"
        [formControl]="numberControl"
        [placeholder]="cardPlaceholder()"
        [readonly]="isLoading()"
        (paste)="onPaste($event)"
        class="text-xl font-mono tracking-wider uppercase"
      />
      <mat-icon matPrefix class="mr-2 text-neutral-9">badge</mat-icon>
      @if (isLoading()) {
        <div matSuffix class="flex items-center">
          <mat-spinner [diameter]="20"></mat-spinner>
        </div>
      }
      <mat-hint
        >Format officiel CCI : 20 caractères (ex : {{ expectedPrefix() }} suivi de 17 chiffres)</mat-hint
      >
      @if (numberControl.hasError('required')) {
        <mat-error>Ce numéro est obligatoire</mat-error>
      }
      @if (numberControl.hasError('agentCardPrefixMismatch')) {
        <mat-error>
          Ce numéro ne correspond pas à votre statut (attendu :
          {{ numberControl.getError('agentCardPrefixMismatch').expected }})
        </mat-error>
      }
      @if (numberControl.hasError('agentCardPrefix')) {
        <mat-error>Préfixe invalide (attendu : {{ expectedPrefix() }})</mat-error>
      }
      @if (numberControl.hasError('agentCardDigits')) {
        <mat-error>Le numéro doit contenir uniquement des chiffres après le préfixe</mat-error>
      }
      @if (numberControl.hasError('agentCardLength')) {
        <mat-error>
          Longueur incorrecte (20 caractères requis, actuellement
          {{ numberControl.getError('agentCardLength').actual }})
        </mat-error>
      }
      @if (numberControl.hasError('cardNotFound')) {
        <mat-error>Numéro introuvable dans le registre officiel</mat-error>
      }
    </mat-form-field>
  </div>
</form>
